// tab
jQuery(function($) {
  // 設定
  var $interval = 3000; // 切り替わりの間隔（ミリ秒）
  var $fade_speed = 1000; // フェード処理の早さ（ミリ秒）
  setInterval(function(){
    $(".s-home-business-gallery__item").each(function() {
      var $active = $(this).children('img.is-active');
      var $next = $active.next("img").length?$active.next("img"):$(this).children('img:first');
      $active.animate({opacity: 0}, 1000).removeClass("is-active");
      $next.animate({opacity: 1}, 1000).addClass("is-active");
    });
  },$interval);
});
